import { Component, OnInit, ViewChild } from '@angular/core';
import {
  ColumnMetadata,
  GenericTableAvlaComponent,
} from 'generic_table_avla_front_components';
import { ListArchivosService } from './service/list-archivos.service';

declare var $: any;

@Component({
  selector: 'app-list-archivos',
  templateUrl: './list-archivos.component.html',
  styleUrls: ['./list-archivos.component.css'],
})
export class ListArchivosComponent implements OnInit {
  @ViewChild('infoLoadFilesTable')
  infoLoadFilesTable: GenericTableAvlaComponent;

  loadFileColumns: ColumnMetadata[];

  loadSpinner: boolean = false;
  loadFilesData: any[];

  constructor(private listArchivosService: ListArchivosService) {
    this.loadFileColumns = [
      new ColumnMetadata('#', 'id', 'fit', true, true),
      new ColumnMetadata('Fecha', 'created_at', 'fit', true, true),
      new ColumnMetadata('Usuario', 'username', 'fit', true, true),
      new ColumnMetadata('Url', 'name', 'fit', true, true),
      new ColumnMetadata('Total Lineas', 'totalLineas', 'fit', true, true),
      new ColumnMetadata(
        'Estado',
        { colName: 'estado', keyData: 'status' },
        'fit',
        true,
        true
      ),
      new ColumnMetadata(
        'Opciones',
        { colName: 'acciones', keyData: 'acciones' },
        'fit',
        true,
        true
      ),
    ];
  }

  ngOnInit(): void {
    this.getLoadFiles();
  }

  public getLoadFiles() {
    this.loadSpinner = true;
    this.listArchivosService.getArchivosMarkList().subscribe(data => {
      this.loadSpinner = false;
      this.loadFilesData = data;
      console.log(this.loadFilesData);
    });
  }

  public downloadFile(url: string, name: string) {
    let a = $("<a style='display: none;'/>");
    a.attr('href', url);
    a.attr('download', name);
    $('body').append(a);
    a[0].click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }
}
